module.exports = __webpack_public_path__ + "img/csr_swiper_02_mobile.ba765e01.jpg";